import type { ElementDefinition } from '../elements/types';
import { isElementDefinition } from '../elements/elementDefinition';

type StructurePathSegment = string | number;
type DefinitionPath = readonly StructurePathSegment[];

function appendDefinitionPath(path: DefinitionPath, segment: StructurePathSegment): DefinitionPath {
    return [...path, segment];
}

function formatDefinitionPath(path: DefinitionPath): string {
    if (!path.length) {
        return '<root>';
    }

    return path.reduce<string>((result, segment) => {
        if (typeof segment === 'number') {
            return `${result}[${segment}]`;
        }

        if (!result.length) {
            return segment;
        }

        return `${result}.${segment}`;
    }, '');
}

export function parseDefinitions(value: unknown, path: DefinitionPath): ElementDefinition[] {
    const pathString = formatDefinitionPath(path);
    if (!Array.isArray(value)) {
        throw new Error(`Expected "${pathString}" to be an array of element definitions.`);
    }

    value.forEach((entry, index) => {
        if (!isElementDefinition(entry)) {
            throw new Error(
                `Invalid element definition at "${formatDefinitionPath(
                    appendDefinitionPath(path, index)
                )}".`
            );
        }
    });

    return value as ElementDefinition[];
}
